import type { HTMLAttributes } from 'react';
import { cn } from '../lib/cn';

export interface ChipProps extends HTMLAttributes<HTMLSpanElement> {
  active?: boolean;
}

/** Rounded filter pill used across discovery + menu screens. */
export function Chip({ active, className, ...props }: ChipProps) {
  return (
    <span
      className={cn(
        'inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border px-3.5 py-1.5 text-[11.5px] font-semibold transition-colors',
        active
          ? 'border-transparent bg-content-primary text-surface-card'
          : 'border-border bg-surface-card text-content-secondary hover:border-border-strong',
        className
      )}
      {...props}
    />
  );
}
